// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c31b96c6","293":"fe5fe4da","453":"ec148307","559":"3fe63d02","732":"497ef9fe","766":"5120f64d","977":"868c6e5b"}[chunkId] + ".chunk.js";
};